var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid text-center min-vh-100 bg-dark"},[_c('div',{staticClass:"row min-vh-100"},[_c('div',{staticClass:"col-12 m-auto py-5"},[_c('h1',{staticClass:"fw-semibold h2"},[_vm._v("Erro 404 - Página não encontrada")])])])])])
}]

export { render, staticRenderFns }